"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserRoles;
(function (UserRoles) {
    UserRoles["ADMIN"] = "admin";
    UserRoles["PAD"] = "pad";
    UserRoles["USER"] = "user";
    UserRoles["INSTALLER"] = "installer";
    UserRoles["SUPPORT"] = "support";
    UserRoles["STOCK"] = "stock";
})(UserRoles = exports.UserRoles || (exports.UserRoles = {}));
var UserLanguage;
(function (UserLanguage) {
    UserLanguage["FR"] = "fr";
    UserLanguage["EN"] = "en";
})(UserLanguage = exports.UserLanguage || (exports.UserLanguage = {}));
